import styled from 'styled-components'

export const PlansContainer = styled.div`
    width: 100%;
    flex: 1;
    text-align: center;
    overflow-y: auto;
`
